import PageEditContainer from './page_edit_container';

const PageEdit = PageEditContainer;
export default PageEdit;
